var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H9C6.79086 3 5 4.79086 5 7V15",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5C14.6843 6.5 15.5307 6.50064 16.1836 6.57422C16.8262 6.64666 17.2191 6.78468 17.5215 7.0166C17.6948 7.1496 17.8504 7.30519 17.9834 7.47852C18.2153 7.78089 18.3533 8.17381 18.4258 8.81641C18.4994 9.46925 18.5 10.3157 18.5 11.5V15.5C18.5 16.6843 18.4994 17.5307 18.4258 18.1836C18.3533 18.8262 18.2153 19.2191 17.9834 19.5215C17.8504 19.6948 17.6948 19.8504 17.5215 19.9834C17.2191 20.2153 16.8262 20.3533 16.1836 20.4258C15.5307 20.4994 14.6843 20.5 13.5 20.5C12.3157 20.5 11.4693 20.4994 10.8164 20.4258C10.1738 20.3533 9.78089 20.2153 9.47852 19.9834C9.30519 19.8504 9.1496 19.6948 9.0166 19.5215C8.78468 19.2191 8.64666 18.8262 8.57422 18.1836C8.50064 17.5307 8.5 16.6843 8.5 15.5V11.5C8.5 10.3157 8.50064 9.46925 8.57422 8.81641C8.64666 8.17381 8.78468 7.78089 9.0166 7.47852C9.1496 7.30519 9.30519 7.1496 9.47852 7.0166C9.78089 6.78468 10.1738 6.64666 10.8164 6.57422C11.4693 6.50064 12.3157 6.5 13.5 6.5Z",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.634ff316568bcc1c0e736e8934465853.svg";
export { ForwardRef as ReactComponent };